import React from 'react';
import Mathru2024 from 'views/Mathru2024';
const MathClubPage = () => {
  return <Mathru2024/>;
};

export default MathClubPage;

